// ─────────────────────────────────────────────────────────────
// CloudflareConfig — Sunday Triggers DAW Cloud Settings
//
// Values are read from environment variables (.env file).
// See .env.example for required variables.
// Never hardcode keys here — use .env locally and set
// environment variables in your hosting platform for production.
//
// WORKER_URL: api.sundaytriggers.com/daw/projects
//   Worker:   st-daw-open-save-sync
//   Bucket:   st-daw-projects
//
// CLERK_PUBLISHABLE_KEY: from Clerk dashboard → API Keys
//   Development:  pk_test_...
//   Production:   pk_live_...
// ─────────────────────────────────────────────────────────────

export const CloudflareConfig = {
    WORKER_URL: import.meta.env.VITE_WORKER_URL as string,
    CLERK_PUBLISHABLE_KEY: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string,
} as const
